<template>
	<!-- Riga di tabella resa come card chiave/valore per la vista da telefono -->
	<v-card outlined class="kv-card" v-on="$listeners">
		<div v-if="title || $slots.title || $slots.actions" class="d-flex align-center pl-3 pr-1" :class="$slots.actions ? 'pt-1' : 'pt-2 pb-1'">
			<div class="text-subtitle-2 font-weight-bold text-truncate flex-grow-1">
				<slot name="title">{{ title }}</slot>
			</div>
			<slot name="actions" />
		</div>
		<v-divider v-if="title || $slots.title || $slots.actions" class="mx-3" />
		<div class="px-3 py-2">
			<!-- contenuto extra sopra le coppie chiave/valore (es. loghi marketplace) -->
			<slot name="top" />
			<div class="d-flex">
				<img v-if="image" :src="immagine" alt="" class="kv-image mr-3" @error="immagineRotta = true" />
				<div class="flex-grow-1 kv-fields">
					<div v-for="campo in fields" :key="campo.label" class="kv-row">
						<span class="kv-k">{{ campo.label }}</span>
						<span class="kv-v" :class="{ 'font-weight-bold': campo.strong }">{{ vuoto(campo.value) ? '-' : campo.value }}</span>
					</div>
				</div>
			</div>
			<!-- contenuto extra sotto (es. campi modificabili) -->
			<div v-if="$slots.default" class="mt-3">
				<slot />
			</div>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'KeyValueCard',
	props: {
		title: { type: String, default: '' },
		// [{ label, value, strong? }]
		fields: { type: Array, default: () => [] },
		// miniatura a sinistra delle coppie chiave/valore
		image: { type: String, default: '' },
		imageFallback: { type: String, default: '' },
	},
	data() {
		return {
			immagineRotta: false,
		};
	},
	computed: {
		immagine() {
			return this.immagineRotta && this.imageFallback ? this.imageFallback : this.image;
		},
	},
	watch: {
		image() {
			this.immagineRotta = false;
		},
	},
	methods: {
		vuoto(value) {
			return value === undefined || value === null || value === '';
		},
	},
};
</script>

<style scoped>
.kv-card {
	width: 100%;
}

.kv-row {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	padding: 3px 0;
	font-size: 14px;
}

.kv-k {
	color: rgba(0, 0, 0, 0.6);
	flex: 0 0 auto;
}

.kv-v {
	text-align: right;
	word-break: break-word;
}

.kv-fields {
	min-width: 0;
}

.kv-image {
	width: 72px;
	height: 72px;
	flex: 0 0 72px;
	object-fit: contain;
	border-radius: 6px;
	background: #f5f5f5;
}
</style>
